import React from 'react';
import PropTypes from 'prop-types';
import Button from 'products/nomad_insurance/components/Button';
import { ButtonWrapper } from './styled';

const Buttons = ({ onDelete, onEdit, disabled }) => {
  return (
    <ButtonWrapper>
      <Button
        color="fuzzyWuzzyBrown"
        thickness="thin"
        onClick={onDelete}
        disabled={disabled}
      >
        Delete
      </Button>
      <Button
        color="pickledBluewood"
        thickness="thin"
        onClick={onEdit}
        disabled={disabled}
      >
        Edit
      </Button>
    </ButtonWrapper>
  );
};

Buttons.propTypes = {
  onDelete: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  disabled: PropTypes.bool
};

export default Buttons;
